import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface FolderColorPickerDialogProps {
  isOpen: boolean;
  folderName: string;
  currentColor?: string;
  onClose: () => void;
  onColorSelect: (color: string | null) => void;
}

const PREDEFINED_COLORS = [
  { name: "Gray (Default)", value: null, color: "#9CA3AF" },
  { name: "Red", value: "#EF4444", color: "#EF4444" },
  { name: "Orange", value: "#F97316", color: "#F97316" },
  { name: "Amber", value: "#F59E0B", color: "#F59E0B" },
  { name: "Yellow", value: "#EAB308", color: "#EAB308" },
  { name: "Lime", value: "#84CC16", color: "#84CC16" },
  { name: "Green", value: "#22C55E", color: "#22C55E" },
  { name: "Emerald", value: "#10B981", color: "#10B981" },
  { name: "Teal", value: "#14B8A6", color: "#14B8A6" },
  { name: "Cyan", value: "#06B6D4", color: "#06B6D4" },
  { name: "Sky", value: "#0EA5E9", color: "#0EA5E9" },
  { name: "Blue", value: "#3B82F6", color: "#3B82F6" },
  { name: "Indigo", value: "#6366F1", color: "#6366F1" },
  { name: "Violet", value: "#8B5CF6", color: "#8B5CF6" },
  { name: "Purple", value: "#A855F7", color: "#A855F7" },
  { name: "Fuchsia", value: "#D946EF", color: "#D946EF" },
  { name: "Pink", value: "#EC4899", color: "#EC4899" },
  { name: "Rose", value: "#F43F5E", color: "#F43F5E" },
];

export function FolderColorPickerDialog({
  isOpen,
  folderName,
  currentColor,
  onClose,
  onColorSelect,
}: FolderColorPickerDialogProps) {
  const [selectedColor, setSelectedColor] = useState<string | null>(currentColor || null);

  const handleSubmit = () => {
    onColorSelect(selectedColor);
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Set Folder Color</DialogTitle>
          <DialogDescription>
            Choose a color for "{folderName}"
          </DialogDescription>
        </DialogHeader>

        <div className="grid grid-cols-6 gap-3 py-4">
          {PREDEFINED_COLORS.map((colorOption) => (
            <button
              key={colorOption.name}
              onClick={() => setSelectedColor(colorOption.value)}
              className={`w-full aspect-square rounded-lg border-2 transition-all hover:scale-110 ${
                selectedColor === colorOption.value
                  ? "border-gray-900 ring-2 ring-gray-900 ring-offset-2"
                  : "border-gray-200 hover:border-gray-400"
              }`}
              style={{ backgroundColor: colorOption.color }}
              title={colorOption.name}
            />
          ))}
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={handleSubmit}>
            Apply Color
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

